import React from 'react'

const Viewproperty = () => {
    return (
        <div>
            <div className="modal fade" id="propertyModal" tabindex="-1" aria-labelledby="propertyModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title font-bold" id="InfoModal">Property Information</h5>
                <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <div className="first-section">
                    <h6 className="font-semibold mb-3">Basic Details:</h6>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Sr No</label>
                            <p id="sr-no-info">12345</p>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Category</label>
                            <p id="category-info">Residential</p>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Sub Category</label>
                            <p id="sub-category-info">1BHK</p>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <label className="form-label">Area Size</label>
                            <p id="area-size-info">1200 sq ft</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Price</label>
                            <p id="price-info">$500,000</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Unit No</label>
                            <p id="unit-no-info">101</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Society</label>
                            <p id="society-info">Green Park</p>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-3">
                            <label className="form-label">Area</label>
                            <p id="area-info">New York</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Amenities</label>
                            <p id="amenities-info">Swimming Pool, Gym, Parking</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Features</label>
                            <p id="features-info">Garden View, Modern Kitchen</p>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Furniture</label>
                            <p id="furniture-info">Fully Furnished</p>
                        </div>
                    </div>
                </div>

                {/* Client Details Section */}
                <div className="mb-3" style={{ borderTop: "2px solid #f0f0f0" }} />
                <div className="second-section">
                    <h6 className="font-semibold mb-3">Client Details:</h6>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Name</label>
                            <p id="client-name-info">John Doe</p>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Mobile No</label>
                            <p id="mobile-info">+1 234 567 890</p>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Email ID</label>
                            <p id="email-info">johndoe@example.com</p>
                        </div>
                    </div>
                </div>

                {/* Status Section */}
                <div className="mb-3" style={{ borderTop: "2px solid #f0f0f0" }} />
                <div className="third-section">
                    <h6 className="font-semibold mb-3">Status:</h6>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">Status</label>
                            <p id="status-info">Available</p>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Source</label>
                            <p id="source-info">Direct</p>
                        </div>
                    </div>
                </div>

                {/* Other sections */}
                <div className="mb-3" style={{ borderTop: "2px solid #f0f0f0" }} />
                <div className="fourth-section">
                    <h6 className="font-semibold mb-3">Other:</h6>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">Remarks</label>
                            <p id="remarks-info">Great location with good amenities.</p>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Keywords</label>
                            <p id="keywords-info">Luxury, 1BHK, Affordable</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center gap-2"
                    style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                    data-bs-dismiss="modal"
                >
                    <i className="bi bi-x-circle"></i> Close
                </button>
            </div>
        </div>
                </div>
            </div>



        </div>
    )
}

export default Viewproperty
